import { useMutation, useQueryClient } from "@tanstack/react-query";

import { comunicadoSistemaService } from "@/services/api/comunicado-sistema.service";
import { comunicadoSistemaKeys } from "@/services/api/queries/comunicado-sistema.queries";

/**
 * Ações da lista admin (publicar/arquivar/excluir). A lista em si é server-side
 * (`useServerDataTable` na tabela); criar/editar vivem nos wizards.
 */
export function useComunicadosSistemaAdmin() {
  const qc = useQueryClient();
  const invalidar = () => qc.invalidateQueries({ queryKey: comunicadoSistemaKeys.all });

  const publicar = useMutation({
    mutationFn: (id: number) => comunicadoSistemaService.publicar(id),
    onSuccess: invalidar,
  });

  const arquivar = useMutation({
    mutationFn: (id: number) => comunicadoSistemaService.arquivar(id),
    onSuccess: invalidar,
  });

  const remover = useMutation({
    mutationFn: (id: number) => comunicadoSistemaService.remove(id),
    onSuccess: invalidar,
  });

  return { publicar, arquivar, remover };
}
